import {Provider, ReactNode} from 'react'
import {cpfMask} from '../../../../utils/cpfMask'
import {Billing} from '../../core/_models'
import BillingDetailContent from './BillingDetailContent'

interface BillingDetailChangeCardProps {
  children: ReactNode
  billing: Billing | null
  sendLinkChangeCart: () => void
}

const BillingDetailChangeCard = ({
  children,
  billing,
  sendLinkChangeCart,
}: BillingDetailChangeCardProps) => {
  return (
    <>
      <div className='modal-body mx-5 mx-xl-7'>
        {billing?.recurrencePayment && (
          <div
            className='border border-gray-300 border-dashed rounded'
            style={{backgroundColor: 'rgb(249, 234, 233)'}}
          >
            <div className='container m-5'>
              <div className='d-flex flex-wrap py-5'>
                <div className='flex-equal me-5'>
                  <table
                    className='table table-flush fw-semibold gy-1'
                    hidden={!billing?.recurrencePayment}
                  >
                    <tbody>
                      <tr>
                        <td className='text-black fw-bold min-w-125px w-125px'>Nome</td>
                        <td className='text-gray-800'>
                          {billing?.recurrencePayment?.creditCard?.holderName}
                        </td>
                      </tr>
                      <tr>
                        <td className='text-black fw-bold min-w-125px w-125px'>Número</td>
                        <td className='text-gray-800'>
                          **** {billing?.recurrencePayment?.creditCard?.lastNumbers}
                        </td>
                      </tr>
                      <tr>
                        <td className='text-black fw-bold min-w-125px w-125px'>Validade</td>
                        <td className='text-gray-800'>
                          {billing?.recurrencePayment?.creditCard?.expirationMonth}/
                          {billing?.recurrencePayment?.creditCard?.expirationYear}
                        </td>
                      </tr>
                      <tr>
                        <td className='text-black fw-bold min-w-125px w-125px'>Tipo</td>
                        <td className='text-gray-800'>{billing?.paymentOption.name}</td>
                      </tr>
                      <tr>
                        <td className='text-black fw-bold min-w-125px w-125px'>CPF</td>
                        <td className='text-gray-800'>
                          {cpfMask(billing?.recurrencePayment?.creditCard?.holderDocument)}{' '}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='flex-equal'>
                  <table className='table table-flush fw-semibold gy-1'>
                    <tbody>
                      <tr>
                        <td>
                          <button
                            className='btn btn-danger col-10 p-11'
                            onClick={() => sendLinkChangeCart()}
                          >
                            Alterar Cartão
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
        {children}
      </div>
    </>
  )
}

export default BillingDetailChangeCard
